<template>
  <div class="contentBox">
    <!-- 欢迎盒子 -->
    <WelcomeBox :flag="true" />
    <!-- 表格数据 -->
    <div class="tableBox">
      <!-- 我的创新券 -->

      <JRtable
        :table-data="currentUsersData"
        :selection="false"
        :show-pagination="true"
        :column="currentUsersColumns"
        @page-change="handlePageChange"
        :pageOptions="pageOptions"
        size="mini"
        :border="true"
        :index="true"
      >
        <div class="innovationVoucher">
          <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
          <span>我的创新券</span>
        </div>
        <template slot="slot_record_status" slot-scope="data">
          <span v-if="data.scope.row.jhzt == 1" style="color: #24ba2f">生效</span>
          <span v-else style="color: #ff3131"> 失效 </span>
        </template>
      </JRtable>
      <!--  -->
      <JRtable
        :table-data="currentUsersData2"
        @page-change="handlePageChange2"
        :column="currentUsersColumns2"
        :pageOptions="pageOptions2"
        :selection="false"
        :show-pagination="true"
        size="mini"
        :border="true"
        :index="true"
      >
        <div class="innovationVoucher">
          <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
          <span>我的兑付情况</span>
          <div style="display: flex; align-items: center">
            <span style="font-size: 16px; margin-left: 20px; margin-right: 20px">创新券</span>
            <el-select v-model="selectValue" multiple collapse-tags popper-class="select-popover-class" size="medium" @change="handleSelectChange" style="width: 250px">
              <el-checkbox :value="selectAll" :indeterminate="indeterminate" @change="selectAllHandle">全选</el-checkbox>
              <el-option v-for="item in options" :key="item.jhbh" :value="item.jhbh" :label="item.jhmc">
                <el-checkbox :value="selectValue.includes(item.jhbh)" :label="item.jhmc" />
              </el-option>
            </el-select>
          </div>
        </div>

        <template slot="slot_record_shjd" slot-scope="data">
          <span :style="getStatusStyle(data.scope.row.spzt)">
            {{ data.scope.row.spztName }}
          </span>
        </template>

        <template slot="slot_record_tools" slot-scope="data">
          <el-button @click="handleViewRedemptionDetails(data.scope.row)" size="mini" type="primary" icon="el-icon-view">查看</el-button>
        </template>
      </JRtable>
    </div>

    <!-- 详情弹框 -->
    <!-- <Dialog :visible.sync="showDialog2" width="1000px" title="详情" :showBtn="false" @close="showDialog2 = false" :append-to-body="true" v-if="false"> -->
      <!-- <template #content>
        <div class="applyform">
          <el-form :model="exchangeForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="统一社会信用代码" prop="tyshxydm" label-width="200px"> <el-input v-model="exchangeForm.tyshxydm" style="width: 250px" clearable disabled></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="机构名称" prop="jgmc" label-width="200px"> <el-input disabled v-model="exchangeForm.fwjj" style="width: 250px"></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="企业法人" prop="qyfr" label-width="200px">
                  <el-input disabled v-model="exchangeForm.qyfr" style="width: 250px" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="企业法人身份证号:" prop="qyfrsfzh" label-width="200px">
                  <el-input disabled v-model="exchangeForm.qyfrsfzh" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="企业法人联系方式：" prop="qyfrlxfs" label-width="200px">
                  <el-input disabled v-model="exchangeForm.qyfrlxfs" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="通讯地址：" prop="lxdh" label-width="200px"> <el-input disabled v-model="exchangeForm.lxdh" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="联系地址：" prop="lxdz" label-width="200px"> <el-input disabled v-model="exchangeForm.lxdz" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="门户网址:" prop="mhwz" label-width="200px"> <el-input disabled v-model="exchangeForm.mhwz" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="联系电话:" prop="lxdh" label-width="200px"> <el-input disabled v-model="exchangeForm.lxdh" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="注册时间:" prop="zcsj" label-width="200px"> <el-input disabled v-model="exchangeForm.zcsj" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="机构简介:" prop="jgjj" label-width="200px"> <el-input disabled v-model="exchangeForm.jgjj" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="机构所在区域:" prop="jgszqy" label-width="200px"> <el-input disabled v-model="exchangeForm.jgszqy" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="机构联系人:" prop="jglxr" label-width="200px"> <el-input disabled v-model="exchangeForm.jglxr" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="机构联系人联系电话:" prop=" jglxrdh" label-width="200px">
                  <el-input disabled v-model="exchangeForm.jglxrdh" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="公司开户行:" prop="gskhh" label-width="200px"> <el-input disabled v-model="exchangeForm.gskhh" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="公司账户名称:" prop="gszhmc" label-width="200px"> <el-input disabled v-model="exchangeForm.gszhmc" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="公司账户账号:" prop="gszhzh" label-width="200px"> <el-input disabled v-model="exchangeForm.gszhzh" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="开户行行号:" prop="khhhh" label-width="200px"> <el-input disabled v-model="exchangeForm.khhhh" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="开户账号联系电话:" prop="khzhlxdh" label-width="200px">
                  <el-input disabled v-model="exchangeForm.khzhlxdh" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="开户账号地址:" prop="khzhdz" label-width="200px"> <el-input disabled v-model="exchangeForm.khzhdz" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="支行名称:" prop="zhmc" label-width="200px"> <el-input disabled v-model="exchangeForm.zhmc" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="机构审核状态:" prop="jgshzt" label-width="200px"> <el-input disabled v-model="exchangeForm.jgshzt" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="审核说明:" prop="shsm" label-width="200px"> <el-input disabled v-model="exchangeForm.shsm" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="数据来源:" prop="sjly" label-width="200px"> <el-input disabled v-model="exchangeForm.sjly" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="申请入驻日期:" prop="sqrzrq" label-width="200px"> <el-input disabled v-model="exchangeForm.sqrzrq" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
              <el-col :span="10">
                <el-form-item label="税号:" prop="jgshzt" label-width="200px"> <el-input disabled v-model="exchangeForm.sh" style="width: 250px" clearable></el-input> </el-form-item
              ></el-col>
            </el-row>
          </el-form>
        </div>
      </template> -->
    <!-- </Dialog> -->

    <!-- 企业新增兑付信息弹窗表单 -->
    <Dialog :visible.sync="showDialog" width="1600px" title="企业兑付申请表" :showBtn="false" @close="showDialog = false" :append-to-body="true">
      <template #content>
        <div class="applyform">
          <!-- 表单组件 -->
          <component :is="test" v-if="showDialog" @closeDialog="closeDialog" :operation="true" :operation2="false" :operation1="true" :uuid="uuid" ref="childRef" :receiptStatus="false"></component>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import WelcomeBox from '@/components/WelcomeBox'
import JRtable from '@/components/Table'
import { getCouponList, getCouponDetail, getMyCoupon, getQuota } from '../../../api/enterprise/index'
import Dialog from '@/views/enterprise/components/Dialog'
import exchangeApplyForm from '@/views/applyForm/exchangeApplyForm'
import exchangeApplyForm2025 from '@/views/applyForm/exchangeApplyForm/index2025.vue'

export default {
  components: {
    WelcomeBox,
    JRtable,
    Dialog,
    exchangeApplyForm,
    exchangeApplyForm2025
  },
  data() {
    return {
      test: 'exchangeApplyForm',
      uuid: '',
      // 我的创新券
      currentUsersData: [],
      currentUsersColumns: [
        {
          label: '创新券计划',
          prop: 'jhmc',
          align: 'center'
        },
        {
          label: '创新券年度',
          prop: 'cxqnd',
          align: 'center'
        },
        {
          label: '创新券额度',
          prop: 'cxqed',
          align: 'center'
        },
        {
          label: '已兑付金额',
          prop: 'ydfje',
          align: 'center'
        },
        {
          label: '可用额度',
          prop: 'cxqkyje',
          align: 'center'
        },
        {
          label: '创新券状态',
          prop: 'zt',
          align: 'center',
          slot: 'slot_record_status'
        }
      ],
      // 我的兑付情况
      currentUsersData2: [],
      currentUsersColumns2: [
        {
          label: '项目名称',
          prop: 'htmc',
          align: 'center',
          // width: '300',
          truncate: true
        },
        {
          label: '合同金额',
          prop: 'htje',
          align: 'center',
          truncate: true
        },
        {
          label: '本次预核准兑付金额',
          prop: 'bckdfje',
          align: 'center',
          truncate: true
        },
        // {
        //   label: '兑付金额',
        //   prop: 'bckdfje',
        //   align: 'center'
        // },
        {
          label: '核准兑付金额',
          prop: 'hzdfje',
          align: 'center',
          truncate: true
        },
        {
          label: '创新券年度',
          prop: 'cxqnd',
          align: 'center',
          truncate: true
        },
        {
          label: '状态',
          align: 'center',
          prop: '',
          // width: 200,
          truncate: true,
          slot: 'slot_record_shjd'
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          // width: 200,
          slot: 'slot_record_tools'
        }
      ],
      // 当前下拉框选择的年度值
      selectValue: [],
      options: [],
      pageOptions: {
        limit: 10,
        page: 1,
        total: 0,
        lqqytysfrz: ''
      },
      pageOptions2: {
        limit: 10,
        page: 1,
        total: 0
      },
      showDialog2: false,
      showDialog: false,
      exchangeForm: {} //详情数据
    }
  },
  computed: {
    selectAll() {
      if (this.selectValue.length) {
        return this.selectValue.length === this.options.length
      }
      return false
    },
    indeterminate() {
      if (this.selectValue.length) {
        return this.selectValue.length !== this.options.length
      }
      return false
    }
  },
  mounted() {
    this.getCouponList()
    this.getMyCoupon()
    this.getEduQuota()
  },
  methods: {
    // 获取额度
    async getEduQuota() {
      const result = await getQuota({ page: 1, size: 99 })
      this.options = result.data.records
    },
    // 获取创新券分页
    async getCouponList() {
      const result = await getCouponList({ ...this.pageOptions, lqqytysfrz: this.$store.state.user.tyshxydm })
      this.currentUsersData = result.data.records
      this.pageOptions.total = result.data.total
    },
    // 获取兑付券
    async getMyCoupon(val = '') {
      const result = await getMyCoupon({ ...this.pageOptions2, jhbh: val, qytyshxydm: this.$store.state.user.tyshxydm, groupType: 1 })
      this.currentUsersData2 = result.data.records
      this.pageOptions2.total = result.data.total
    },
    // 创新券分页控制
    handlePageChange(val) {
      this.pageOptions.page = val.page
      this.pageOptions.limit = val.limit
      this.getCouponList()
    },
    // 我的兑付的分页控制
    handlePageChange2(val) {
      this.pageOptions2.page = val.page
      this.pageOptions2.limit = val.limit
      this.getMyCoupon()
    },
    // 点击查看详情
    async handleViewRedemptionDetails(val) {
      if ( val.oldTag == 2 || val.oldTag == 1 || val.dfpc == '2024-02') {
        this.test = 'exchangeApplyForm2025'
      } else{
        this.test = 'exchangeApplyForm'
      }
      // this.showDialog2 = true
      // 后续为跳转页面
      // const result = await getCouponDetail({ tyshxydm: val.qytyshxydm })
      // this.exchangeForm = result.data
      this.showDialog = true
      this.$nextTick(() => {
        this.uuid = val.dfid // 记录uuid
        this.$refs.childRef.editForm(val.dfid)
      })
    },
    // 点击全选
    selectAllHandle(bool) {
      this.selectValue = bool ? this.options.map((v) => v.jhbh) : []
      this.getMyCoupon(this.selectValue.join(','))
    },
    // 点击下拉框
    handleSelectChange(val) {
      // console.log(val)
      this.selectValue = val
      this.getMyCoupon(this.selectValue.join(','))
    },
    // 关闭弹窗
    closeDialog() {
      this.showDialog = false
    },
    getStatusStyle(status) {
      switch (status) {
        case '007':
          return { color: 'red' }
        case '010':
          return { color: 'red' }
        case '012':
          return { color: 'red' }
        case '014':
          return { color: 'red' }
        case '018':
          return { color: 'red' }
        default:
          return { color: 'rgb(103, 194, 58)' }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  max-height: 260px !important;
  overflow: auto !important;
}
.contentBox {
  width: 100%;
  height: 100%;

  .tableBox {
    margin-top: 25px;
  }
}

::v-deep .el-table::before {
  background-color: transparent !important;
}

.innovationVoucher {
  font-weight: bold;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #333333;
  margin-bottom: 15px;

  span {
    margin-left: 10px;
  }
}

/* 控制全选按钮样式 */
.select-popover-class .el-scrollbar__view > .el-checkbox {
  padding: 5px 20px;
}

/* 取消多选框触发事件 */
.select-popover-class .el-scrollbar__view > li .el-checkbox {
  pointer-events: none;
}

/* 隐藏多选框选中勾选样式 √ */
.select-popover-class .el-scrollbar__view > li::after {
  display: none;
}
// 企业兑付申请表单样式
.applyform {
  padding: 10px;
  .box-cards {
    margin-bottom: 10px;
    .card-title {
      display: flex;
      align-items: center;
      div {
        width: 5px;
        height: 13px;
        background: rgb(88, 155, 248);
        margin-right: 10px;
      }
      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}
::v-deep .el-form {
  .el-form-item {
    display: flex;
  }
  .el-form-item__content {
    margin-left: 10px !important;
  }
}
</style>
